export default __webpack_public_path__ + "static/media/jewelry.2500d036.svg";